import React, { Component } from 'react';

import Filterable from '@components/Filterable/Filterable';
import IconsList from './IconsList/IconsList';
import { iconsSet } from './iconset';
import { FILTERS } from './constants';

/*
  Presentational component for Icons
*/

class Icons extends Component {
  render() {
    return (
      <Filterable
        customClasses={'main-content black'}
        filters={FILTERS}
        data={iconsSet}
        placeholder={'icon'}
      >
        <IconsList/>
      </Filterable>
    );
  }
}

export default Icons;



// WEBPACK FOOTER //
// ./src/containers/foundations/Icons/Icons.js